// extracted by mini-css-extract-plugin
export default {"table-widget":"TableWidget_table-widget__1pvdy","table":"TableWidget_table__X5kob","header":"TableWidget_header__j86h4"};